import { Titles } from './common'
import { Image } from './image'

export enum ShippingStatus {
  UNKNOWN = 'Unknown',
  CHINA_ONLY = 'China Only',
  GLOBAL_SHIPPING = 'Global Shipping',
}

export interface City {
  en?: string
  zhCn: string
}

export interface State {
  en?: string
  zhCn: string
}

export interface Location {
  city: City
  state: State
}

type Thumbnail = Image[]

export interface Sku {
  id: string
  quantity: number
  prices: number[]
}

export interface Ratings {
  delivery: number
  product: number
  service: number
}

export interface Shop {
  id: number
  type: string
  titles: Titles
  ratings: Ratings
}

export interface Category {
  id: number
  parentId: number
  status: string
  titles: Titles
}

export interface Property {
  titles: Titles
  value: Titles
}

export interface SkuOption {
  id: any
  categoryId: number
  titles: Titles
  thumbnail?: Thumbnail
}

export interface SKUGroup {
  skuCategories: SkuCategory[]
  skuOptions: SkuOption[]
}

export interface SkuCategory {
  id: number
  titles: Titles
  optionsCount: number
}

export interface Schedule {
  startsAt: number
  endsAt: number
}

type Destination = Titles
type Origin = Titles

export interface Shipping {
  destination: Destination
  origin: Origin
  price: number
}

export interface Product extends CommonProduct {
  reviewsCount: number
  positiveRatingsCount: number
  negativeRatingsCount: number
  nick: string
  openIid: string
  openId: number
  cid: number
  desc: string
  buyEnabled: boolean
  cartEnabled: boolean
  hasCoupon: boolean
  hasSku: boolean
  stock: number
  covers: Image[]
  skus: Sku[]
  categories: Category[]
  properties: Property[]
  skuOptions: SkuOption[]
  skuCategories: SkuCategory[]
  schedule: Schedule
  shipping: Shipping
}

export interface CoolCrazyProduct {
  description: string
  picture: string
  taobaoId: string
  title: string
}

interface Promotion {
  minPrice: number
  maxPrice: number
}

export interface Seller {
  id: number
  titles: Titles
  type: 'tmall' | string
}

export interface CommonProduct {
  banned: boolean
  cover: Image
  deletedFromProvider: boolean
  id: string
  locale: string
  location: Location
  maxPrice: number
  minPrice: number
  multipleOrderQuantity: number
  promotion?: Promotion
  sellerId: number
  shop: Shop
  sold: number
  titles: Titles
  thumbnails?: Image[]
  seller?: Seller
}

export enum ProductBadge {
  TMALL = 'tmall',
  MARKET = 'supermarket',
}
